import React from 'react';
import { Section } from '../ui/Section';
import { Search, ShieldCheck, BookOpen, Gavel, Wallet, Flag } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <Search className="w-6 h-6 text-orange-500" data-id="element-430" />,
    title: 'Find the Hidden Homes',
    desc: 'Use our simple search method to spot cheap homes in your area before anyone else sees them.'
  }, {
    icon: <ShieldCheck className="w-6 h-6 text-orange-500" data-id="element-431" />,
    title: 'Analyze the Good Deals Safely',
    desc: 'Use our easy checklist to spot the truly good deals and make sure there are no hidden debts or surprises before you ever bid — zero risk to you.'
  }, {
    icon: <BookOpen className="w-6 h-6 text-orange-500" data-id="element-432" />,
    title: 'Understand Everything',
    desc: 'We translate any scary legal words into plain English, so you always know exactly what you are signing up for.'
  }, {
    icon: <Gavel className="w-6 h-6 text-orange-500" data-id="element-433" />,
    title: 'The Maximum Bidding Method',
    desc: 'Learn the simple way to set your top price and bid with confidence, so you win the home without ever paying a single dollar too much.'
  }, {
    icon: <Wallet className="w-6 h-6 text-orange-500" data-id="element-434" />,
    title: 'Buy Without Big Cash',
    desc: 'Learn the simple trick to buy your home cheap now and switch to a normal, affordable monthly payment later.'
  }, {
    icon: <Flag className="w-6 h-6 text-orange-500" data-id="element-435" />,
    title: 'Get the Keys',
    desc: 'Follow the final steps to lock in your home at up to 50% off and officially become a homeowner.'
  }];
  return <Section theme="onyx" className="border-b border-slate-200" data-id="element-436">
      <div className="mb-6 flex flex-col items-start" data-id="element-437">
        <div className="flex items-center gap-4 mb-4" data-id="element-438">
          <div className="h-1 w-8 bg-orange-500 rounded-full" data-id="element-439"></div>
          <span className="text-orange-600 text-xs font-bold tracking-wider uppercase" data-id="element-440">
            The Simple Steps Inside
          </span>
        </div>
      </div>

      <h2 className="text-3xl md:text-5xl font-display font-bold mb-16 text-slate-900" data-id="element-441">
        Your step-by-step path to a home 50% off.
      </h2>

      <div className="space-y-4" data-id="element-442">
        {items.map((item, idx) => <div key={idx} className="bg-white p-6 md:p-8 rounded-2xl border border-slate-200 shadow-sm flex flex-col md:flex-row gap-6 items-start md:items-center hover:shadow-md hover:border-orange-200 transition-all duration-300" data-id="element-443">
            <div className="flex items-center gap-6 shrink-0" data-id="element-444">
              <span className="flex items-center justify-center w-12 h-12 rounded-full bg-orange-500 text-white text-xl font-display font-bold shrink-0" data-id="element-445">
                {idx + 1}
              </span>
              <div className="bg-orange-50 p-3 rounded-xl" data-id="element-446">{item.icon}</div>
            </div>
            <div data-id="element-447">
              <h3 className="text-xl font-display font-bold mb-2 text-slate-900" data-id="element-448">
                {item.title}
              </h3>
              <p className="text-slate-600 text-lg" data-id="element-449">{item.desc}</p>
            </div>
          </div>)}
      </div>

      {/* Walk-away reassurance callout */}
      <div className="mt-12 bg-green-50 border border-green-200 rounded-2xl p-8 md:p-10 text-center max-w-2xl mx-auto" data-id="element-450">
        <h3 className="text-2xl md:text-3xl font-display font-bold text-slate-900 mb-4" data-id="element-451">
          And if a deal isn't right? Just walk away. 😊
        </h3>
        <p className="text-lg text-slate-600 leading-relaxed" data-id="element-452">
          Our step-by-step beginner-friendly blueprint is designed to win you a
          good deal — or just walk away and wait for the next opportunity. And
          you'll keep going until you have it,{' '}
          <span className="font-semibold text-slate-900" data-id="element-453">
            because you will!
          </span>
        </p>
      </div>
    </Section>;
}